import {
  BurgerSvg,
  LotterySvg,
  NavMyBetsSvg,
  NavCasinoSvg,
  NavBonusesSvg,
  NavBettingLiveSvg,
  NavBettingSvg,
  EModalTypes,
} from 'react-gldn-kit';

import { NavigationButton } from './types';
import { ERouteNames } from 'Routes/types';
import { IS_DEVELOPMENT_MODE } from 'constants/ui';
import CasinoDrawer from 'components/Drawers/CasinoDrawer';

export const BETTING_NAVIGATION_BAR: NavigationButton[] = [
  {
    icon: <BurgerSvg />,
    text: 'navigationBar.bettingMenu',
    isPopUp: true,
    modalType: EModalTypes.DrawerBettingModal,
  },
  {
    icon: <NavBettingLiveSvg />,
    text: 'navigationBar.bettingLive',
    // @ts-ignore
    path: !IS_DEVELOPMENT_MODE ? '/betting/live' : ERouteNames.BettingLive,
  },
  {
    icon: <NavBettingSvg />,
    text: 'navigationBar.bettingPrematch',
    // @ts-ignore
    path: !IS_DEVELOPMENT_MODE ? '/betting/sport' : ERouteNames.BettingPrematch,
  },
  {
    icon: <NavCasinoSvg />,
    text: 'navigationBar.casino',
    path: ERouteNames.CasinoHome,
  },
  {
    icon: <NavMyBetsSvg />,
    text: 'navigationBar.myBets',
    isAuthDependes: true,

    // @ts-ignore --- BECAUSE OF FRAME
    path: IS_DEVELOPMENT_MODE ? undefined : '/profile/history-operations',
    isPopUp: IS_DEVELOPMENT_MODE ? true : undefined,
    modalType: IS_DEVELOPMENT_MODE ? EModalTypes.InGameTickets : undefined,
    // EModalTypes.BettingTransaction,
  },
];

export const CASINO_NAVIGATION_BAR: NavigationButton[] = [
  {
    icon: <BurgerSvg />,
    text: 'navigationBar.casinoMenu',
    isPortal: true,
    CustomComponent: CasinoDrawer,
  },

  {
    icon: <NavCasinoSvg />,
    text: 'navigationBar.casino',
    path: ERouteNames.CasinoHome,
  },
  {
    icon: <NavBettingSvg />,
    text: 'navigationBar.bettingPrematch',
    path: ERouteNames.FrameBetting,
    isBetting: true,
  },

  // IS_DEVELOPMENT_MODE
  //   ?
  {
    icon: <LotterySvg />,
    text: 'navigationBar.promoCode',
    isAuthDependes: true,
    path: ERouteNames.PromoCode,
  },
  {
    icon: <NavBonusesSvg />,
    text: 'navigationBar.bonus',
    isPopUp: true,
    modalType: EModalTypes.Bonuses,
    isAuthDependes: true,
  },
];
